import { Text } from "@fluentui/react-components";
import { faChevronRight } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PropsWithChildren } from "react";
import { Link } from "react-router-dom";

type LeftBarMobileLinkProps = {
  to: string;
  onClick?: () => void;
  isAElement?: boolean;
  newTab?: boolean;
};

export function LeftBarMobileLink({
  to,
  onClick,
  isAElement,
  newTab,
  children,
}: PropsWithChildren<LeftBarMobileLinkProps>) {
  const className = "flex flex-row justify-between w-full items-center";

  if (isAElement) {
    return (
      <a
        target={newTab ? "_blank" : undefined}
        href={to}
        onClick={onClick}
        className={className}
      >
        <Text size={400}>{children}</Text>
        <FontAwesomeIcon icon={faChevronRight} />
      </a>
    );
  }

  return (
    <Link
      target={newTab ? "_blank" : undefined}
      className={className}
      onClick={onClick}
      to={to}
    >
      <Text size={400}>{children}</Text>
      <FontAwesomeIcon icon={faChevronRight} />
    </Link>
  );
}
